export const SOCIO_CATEGORIES = [
  { value: "Familia IAJAD", uf: 30, desc: "Familias con alumnos o egresados del IH hasta 24 años" },
  { value: "Familia", uf: 38, desc: "Familias con hijos o agregados de hasta 24 años" },
  { value: "Pareja", uf: 28, desc: "Parejas con hijos hasta 2 años" },
  { value: "Individual", uf: 18, desc: "Personas sin hijos" },
  { value: "Estudiante", uf: 12, desc: "Jóvenes entre 18 a 24 años" },
  { value: "Senior", uf: 8, desc: "Personas mayores a 65 años" },
  { value: "Senior Pareja", uf: 15, desc: "Parejas mayores a 65 años" },
  { value: "Olami", uf: 10, desc: "Familias que residan fuera de Chile" },
  { value: "Comunitario", uf: 12, desc: "Familias sólo domingos y festivos nacionales y religiosos" },
  { value: "Kabod", uf: 0, desc: "Para personas mayores a 80 años" },
];

export const categoryFeeUF = (cat) => {
  const norm = (s) => (s || "").trim().toLowerCase();
  const found = SOCIO_CATEGORIES.find((c) => norm(c.value) === norm(cat));
  return found ? found.uf : null;
};
